<div class="mo-wrapper margin-top-2rem">

  <!-- Section Header -->
  <div class="mo-header">
    <span class="mo-header__title">{{ 'atgHomepageMyOrders.title' | cxTranslate }}</span>
  </div>

  <!-- Outer card with border + border-radius -->
  <div class="mo-card">

    <!-- Tab Bar -->
    <div class="mo-tabs" role="tablist">

      <button
        class="mo-tab"
        [class.mo-tab--active]="activeTab === 'date'"
        (click)="setTab('date')"
        role="tab"
        [attr.aria-selected]="activeTab === 'date'"
        aria-controls="panel-date"
        id="tab-date"
      >{{ 'atgHomepageMyOrders.tabs.searchByDate' | cxTranslate }}</button>

      <div class="mo-tab-divider"></div>

      <button
        class="mo-tab"
        [class.mo-tab--active]="activeTab === 'order'"
        (click)="setTab('order')"
        role="tab"
        [attr.aria-selected]="activeTab === 'order'"
        aria-controls="panel-order"
        id="tab-order"
      >{{ 'atgHomepageMyOrders.tabs.searchByOrder' | cxTranslate }}</button>

      <div class="mo-tab-divider"></div>

      <button
        class="mo-tab"
        [class.mo-tab--active]="activeTab === 'status'"
        (click)="setTab('status')"
        role="tab"
        [attr.aria-selected]="activeTab === 'status'"
        aria-controls="panel-status"
        id="tab-status"
      >{{ 'atgHomepageMyOrders.tabs.searchByStatus' | cxTranslate }}</button>

    </div><!-- /mo-tabs -->

    <!-- ── Panel: Search by Date ───────────────────────── -->
    <div
      class="mo-panel"
      id="panel-date"
      role="tabpanel"
      aria-labelledby="tab-date"
      [class.mo-panel--active]="activeTab === 'date'"
    >
      <div class="mo-date-row">
        <div class="mo-date-cell">
          <span class="mo-sep">{{ 'atgHomepageMyOrders.labels.fromDate' | cxTranslate }}</span>
          <div class="input-group valid-to position-relative">
            <input type="text" class="mo-input mo-input--date" [placeholder]="knBrDateFormatService.getDateFormat()" name="startDate"
              ngbDatepicker #startDp="ngbDatepicker" container="body" [(ngModel)]="startDateStruct"
              (ngModelChange)="onStartDateChange($event)" [disabled]="showPast90Days"
              [attr.aria-label]="'atgHomepageMyOrders.labels.fromDate' | cxTranslate" />
            <div class="input-group-append">
              <button type="button" class="btn calendar p-0 h-auto w-auto" (click)="startDp.toggle()"
                [disabled]="showPast90Days" [attr.aria-label]="'atgHomepageMyOrders.labels.fromDate' | cxTranslate">
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mo-date-cell">
          <span class="mo-sep">{{ 'atgHomepageMyOrders.labels.toDate' | cxTranslate }}</span>
          <div class="input-group valid-to position-relative">
            <input type="text" class="mo-input mo-input--date" [placeholder]="knBrDateFormatService.getDateFormat()" name="endDate"
              ngbDatepicker #endDp="ngbDatepicker" container="body" [(ngModel)]="endDateStruct"
              (ngModelChange)="onEndDateChange($event)" [disabled]="showPast90Days"
              [attr.aria-label]="'atgHomepageMyOrders.labels.toDate' | cxTranslate" />
            <div class="input-group-append">
              <button type="button" class="btn calendar p-0 h-auto w-auto" (click)="endDp.toggle()"
                [disabled]="showPast90Days" [attr.aria-label]="'atgHomepageMyOrders.labels.toDate' | cxTranslate">
                <i class="far fa-calendar-alt"></i>
              </button>
            </div>
          </div>
        </div>
        <label class="mo-date-cell mo-date-cell--checkbox">
          <input type="checkbox" class="mo-past90__checkbox" [(ngModel)]="showPast90Days" (ngModelChange)="onPast90DaysToggle()" />
          <span>{{ 'atgHomepageMyOrders.labels.past90Days' | cxTranslate }}</span>
        </label>
      </div>
      <div class="mo-actions">
        <button class="btn btn-primary" (click)="onSearch()">{{ 'atgHomepageMyOrders.button.search' | cxTranslate }}</button>
        <button class="btn btn-outline-primary" (click)="onReset()">{{ 'atgHomepageMyOrders.button.reset' | cxTranslate }}</button>
      </div>
    </div>

    <!-- ── Panel: Search by Order# / PO# ──────────────── -->
    <div
      class="mo-panel"
      id="panel-order"
      role="tabpanel"
      aria-labelledby="tab-order"
      [class.mo-panel--active]="activeTab === 'order'"
    >
      <div class="mo-fields">
        <input
          type="text"
          class="mo-input"
          [placeholder]="'atgHomepageMyOrders.labels.salesOrderNumber' | cxTranslate"
          [(ngModel)]="searchModel.salesOrderNumber"
          [attr.aria-label]="'atgHomepageMyOrders.labels.salesOrderNumber' | cxTranslate"
        />
        <span class="mo-sep">{{ 'atgHomepageMyOrders.labels.separatorOr' | cxTranslate }}</span>
        <input
          type="text"
          class="mo-input"
          [placeholder]="'atgHomepageMyOrders.labels.purchaseOrderNumber' | cxTranslate"
          [(ngModel)]="searchModel.purchaseOrderNumber"
          [attr.aria-label]="'atgHomepageMyOrders.labels.purchaseOrderNumber' | cxTranslate"
        />
        <span class="mo-sep">{{ 'atgHomepageMyOrders.labels.separatorOr' | cxTranslate }}</span>
        <input
          type="text"
          class="mo-input"
          [placeholder]="'atgHomepageMyOrders.labels.invoiceNumber' | cxTranslate"
          [(ngModel)]="searchModel.invoiceNumber"
          [attr.aria-label]="'atgHomepageMyOrders.labels.invoiceNumber' | cxTranslate"
        />
      </div>
      <div class="mo-actions">
        <button class="btn btn-primary" (click)="onSearch()">{{ 'atgHomepageMyOrders.button.search' | cxTranslate }}</button>
        <button class="btn btn-outline-primary" (click)="onReset()">{{ 'atgHomepageMyOrders.button.reset' | cxTranslate }}</button>
      </div>
    </div>

<!-- ── Panel: Search by Status ────────────────────── -->
    <div
      class="mo-panel"
      id="panel-status"
      role="tabpanel"
      aria-labelledby="tab-status"
      [class.mo-panel--active]="activeTab === 'status'"
    >
      <div class="mo-status-grid">

        <!-- Column 1: All Orders -->
        <div class="mo-status-col mo-status-col--all">
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.ALL_ORDERS"
              (change)="onStatusCheck('ALL_ORDERS')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.allOrders' | cxTranslate }}</span>
          </label>
        </div>

        <!-- Column 2: Open / Shipped / Cancelled -->
        <div class="mo-status-col">
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.O"
              (change)="onStatusCheck('O')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.openOrders' | cxTranslate }}</span>
          </label>
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.S"
              (change)="onStatusCheck('S')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.shippedOrders' | cxTranslate }}</span>
          </label>
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.X"
              (change)="onStatusCheck('X')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.cancelledOrders' | cxTranslate }}</span>
          </label>
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.C"
              (change)="onStatusCheck('C')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.closedOrders' | cxTranslate }}</span>
          </label>
        </div>

        <!-- Column 3: Past 30 / 60 / 90 Days -->
        <div class="mo-status-col">
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.past30Days"
              (change)="onStatusCheck('past30Days')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.past30DayOrders' | cxTranslate }}</span>
          </label>
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.past60Days"
              (change)="onStatusCheck('past60Days')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.past60DayOrders' | cxTranslate }}</span>
          </label>
          <label class="mo-status-check">
            <input
              type="checkbox"
              [checked]="statusSelection.past90Days"
              (change)="onStatusCheck('past90Days')"
            />
            <span>{{ 'atgHomepageMyOrders.labels.past90DayOrders' | cxTranslate }}</span>
          </label>
        </div>

      </div><!-- /mo-status-grid -->

      <div class="mo-actions">
        <button class="btn btn-primary" (click)="onSearch()">{{ 'atgHomepageMyOrders.button.search' | cxTranslate }}</button>
        <button class="btn btn-outline-primary" (click)="onReset()">{{ 'atgHomepageMyOrders.button.reset' | cxTranslate }}</button>
      </div>
    </div>

  </div><!-- /mo-card -->
</div>
